export const VideoStateChanged = 'sos.Monitoring.Video.VideoStateChanged';
export interface VideoStateChanged {
	type: typeof VideoStateChanged;
	state: 'play' | 'prepare' | 'stop' | 'pause' | 'resume' | 'ended' | 'error';
	uri: string;
	x: number;
	y: number;
	width: number;
	height: number;
}
